'use es6';

export default ((input, isValid) => {
  return {
    input,
    isValid
  };
});